import LabelUtil from "bpmn-js/lib/util/LabelUtil";

LabelUtil.hasExternalLabel = semantic => {
  return semantic.$type !== "bpmn:Process";
};
